import * as types from '../../constants/app/inAppIconsConstants';

export const inAppIconsListRequest = ({
  callback,
  error,
}) => ({
  type: types.IN_APP_ICONS_LIST_REQUEST,
  callback,
  error,
});
